import React, { FC, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import { Box, IconButton } from "@mui/material";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./style";

interface CarouselProps {
  open: boolean;
  selectedImage: any;
  images: any[];
  handleClose: () => void;
}

const ImagesCarousel: FC<CarouselProps> = ({
  open,
  selectedImage,
  images,
  handleClose,
}: CarouselProps) => {
  const [selectedIndex, setSelectedIndex] = React.useState<number>(0);

  useEffect(() => {
    if (selectedImage) {
      setSelectedIndex(
        images.findIndex((obj: any) => obj.title === selectedImage.title),
      );
    }
  }, [selectedImage]);

  return (
    <Backdrop sx={{
      ...classes.root,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }} open={open} onClick={() => handleClose()} style={{ zIndex: 9999 }}>
      <IconButton
        aria-label="close"
        size="large"
        sx={classes.closeIcon}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>

      <Box display="flex" alignItems="center">
        <IconButton
          aria-label="previous"
          size="large"
          onClick={(e) => {
            e.stopPropagation(); setSelectedIndex(selectedIndex - 1);
          }}
          sx={{
            position: "absolute",
            left: "20px",
            zIndex: 10000,
          }}
          disabled={selectedIndex === 0}
        >
          <ArrowCircleLeftOutlinedIcon />
        </IconButton>
        <img
          src={images[selectedIndex].img}
          alt={images[selectedIndex].title}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "cover",
            margin: "0 auto",
          }}
        />
        <IconButton
          aria-label="next"
          size="large"
          onClick={(e) => {
            e.stopPropagation(); setSelectedIndex(selectedIndex + 1);
          }}
          sx={{
            position: "absolute",
            right: "20px",
            zIndex: 10000,
          }}
          disabled={selectedIndex === images.length - 1}
        >
          <ArrowCircleRightOutlinedIcon />
        </IconButton>
      </Box>
    </Backdrop>
  );
};

export default ImagesCarousel;
